import { JSEncrypt } from 'jsencrypt'
import CryptoJS from 'crypto-js'
// 全局的回调函数，保持app端的异步通知
const responseCallbacks = {}
const errorCallbacks = {}
const completeCallbacks = {}
let connectKey = ''
const iv = '12345678' // 偏移量
let encrypt_ws_id = ''
// 判断平台
export function platformAgent() {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  const isHarmony = u.indexOf('Harmony') > -1 //鸿蒙终端
  let platform = 'pc'
  if (isAndroid) {
    platform = 'android'
    // alert('这是Android')
  }
  if (isiOS) {
    // alert('这是IOS')
    platform = 'ios'
  }
  if (isHarmony) {
    platform = 'Harmony'
  }
  return platform
}
// 生成唯一标识ID
function generateUUID() {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
    c
  ) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return uuid
}
// 调用os方法
function execute(methodName, params = {}) {
  const ws_id = generateUUID()
  const obj = {}
  obj.ws_id = ws_id
  obj.params = params.params
  // alert(JSON.stringify(obj.params))
  if (params.success) {
    responseCallbacks[ws_id] = params.success
    delete params.success
  }
  if (params.fail) {
    errorCallbacks[ws_id] = params.fail
    delete params.fail
  }
  if (params.complete) {
    completeCallbacks[ws_id] = params.complete
    delete params.complete
  }
  // 进行参数处理 如果有function 的进行方法保存
  if (Object.prototype.toString.call(obj.params) === '[object Object]') {
    if (obj.params.func && typeof obj.params.func === 'function') {
      const func_id = generateUUID()
      obj.params.func_id = func_id
      responseCallbacks[func_id] = obj.params.func
      delete obj.params.func
    }
  }
  // 进行参数处理 如果是批量设置右上角菜单，则进行右上角惨淡判断
  if (
    Object.prototype.toString.call(obj.params) === '[object Array]' &&
    obj.params.length > 0
  ) {
    obj.params.forEach(item => {
      if (item.func && typeof item.func === 'function') {
        const func_id = generateUUID()
        item.func_id = func_id
        responseCallbacks[func_id] = item.func
        delete item.func
      }
    })
  }
  try {
    const platform = platformAgent()
    if (platform === 'android') {
      let params = obj.params
      if (typeof params == 'object') {
        params = JSON.stringify(params)
      }
      if (methodName === 'nativeHttpEncrypt') {
        // 参数加密
        let res = jiemi(window.syjs.nativeHttpEncrypt(getParams(params)))
        return res
      } else if (methodName === 'nativeHttpDecrypt') {
        // 参数解密
        let res = window.syjs.nativeHttpDecrypt(getParams(params))
        return res
      } else {
        window.syjs.nativeJsbridge(methodName, getParams(JSON.stringify(obj)))
      }
    } else if (platform === 'ios') {
      if (methodName === 'nativeEncryKey') {
        encrypt_ws_id = ws_id
        window.webkit.messageHandlers.WKWebViewJavascriptBridge.postMessage(
          'nativeEncryKey' + '?params=' + JSON.stringify(obj)
        )
      } else {
        mn = methodName
        window.webkit.messageHandlers.WKWebViewJavascriptBridge.postMessage(
          methodName + '?params=' + getParams(JSON.stringify(obj))
        )
      }
    }
  } catch (e) {
    console.error(`调用APP接口失败${e}`)
  }
}
var mn = '' // 方法名
// os调用前端的方法
window._handleMessage1 = function(params) {
  if ((!params || !params.key) && encrypt_ws_id != params.ws_id) {
    alert('缺少参数')
    return
  }
  if (encrypt_ws_id != params.ws_id) {
    params = jiemi(params.key)
    // alert(JSON.stringify(params))
  }

  if (typeof params === 'string') {
    params = JSON.parse(params)
  }
  if (mn == 'nativeHttpEncrypt') {
    // alert(params.code)
  }
  let ws_id = params.ws_id
  let code = params.code
  let data = params.data
  if (data) {
    if (Object.prototype.toString.call(data) === '[object String]') {
      try {
        data = JSON.parse(data)
      } catch (error) {}
    }
  }
  let successCallback = void 0
  let failCallback = void 0
  let completeCallback = void 0
  if (ws_id) {
    if (code === '200') {
      successCallback = responseCallbacks[ws_id]
      successCallback && successCallback(data)
      // delete responseCallbacks[ws_id]
    } else {
      failCallback = errorCallbacks[ws_id]
      failCallback && failCallback(data)
      // delete errorCallbacks[ws_id]
    }
    completeCallback = completeCallbacks[ws_id]
    completeCallback && completeCallback(data)
    // delete completeCallback[ws_id]
  } else {
    console.error(`no success callback`)
  }
}
export const WSBridge = {
  openUrl(params) {
    execute('openUrl', params)
  },
  clipboard(params) {
    execute('clipboardv', params)
  },
  getGeoLocation(params) {
    execute('getGeoLocation', params)
  },
  clearCache(params) {
    // if (platformAgent() === 'android') {
    //   window.syjs.nativeJsBridge.clearCache()
    // } else if (platformAgent() === 'ios') {
    //   window.webkit.messageHandlers.WKWebViewJavascriptBridge.postMessage(
    //     'clearCache'
    //   )
    // }
    execOpenFun('clearCache', params)
  },
  getAppVersion(params) {
    execOpenFun('getAppVersion', params)
  },
  launchApp(params) {
    execute('launchApp', params)
  },
  vibrate(params) {
    execute('vibrate', params)
  },
  sendMsg(params) {
    execute('sendMsg', params)
  },
  callPhone(params) {
    execute('callPhone', params)
  },
  getNetWorkInfo(params) {
    execute('getNetWorkInfo', params)
  },
  getVendorInfo(params) {
    execute('getVendorInfo', params)
  },
  getDeviceId(params) {
    execute('getDeviceId', params)
  },
  setOrientation(params) {
    execute('setOrientation', params)
  },
  reload(params) {
    execute('reload', params)
  },
  closeWebView(params) {
    execute('closeWebView', params)
  },
  openWebView(params) {
    execute('openWebView', params)
  },
  openOriginalView(params) {
    execute('openOriginalView', params)
  },
  setRightMenu(params) {
    execute('setRightMenu', params)
  },
  hiddenRightBtn(params) {
    execute('hiddenRightBtn', params)
  },
  setLeftBtn(params) {
    execute('setLeftBtn', params)
  },
  setNavRightBtn(params) {
    execute('setNavRightBtn', params)
  },
  hookBackBtn(params) {
    execute('hookBackBtn', params)
  },
  hookSysBack(params) {
    execute('hookSysBack', params)
  },
  hiddenBackBtn(params) {
    execute('hiddenBackBtn', params)
  },
  hiddenStatusBar(params) {
    execute('hiddenStatusBar', params)
  },
  showStatusBar(params) {
    execute('showStatusBar', params)
  },
  hiddenNavigationBar(params) {
    execute('hiddenNavigationBar', params)
  },
  showNavigationBar(params) {
    execute('showNavigationBar', params)
  },
  setNavigationBarTitle(params) {
    execute('setNavigationBarTitle', params)
  },
  scan(params) {
    execute('scan', params)
  },
  chooseImage(params) {
    execute('chooseImage', params)
  },
  chooseMessageFile(params) {
    execute('chooseMessageFile', params)
  },
  nativeHttpEncrypt(params) {
    return execute('nativeHttpEncrypt', params)
  },
  nativeHttpDecrypt(params) {
    return execute('nativeHttpDecrypt', params)
  },
  nativeEncryKey(params) {
    execute('nativeEncryKey', params)
  },
  shareToWechat(params) {
    execute('shareToWechat', params)
  },
  getAddress(params) {
    execute('getAddress', params)
  },
  openOriActivity(params) {
    execute('openOriActivity', params)
  },
  getHybridVersion(params) {
    execOpenFun('getHybridVersion', params)
  }
}

var val = ''
export const data1 = randomString(16)
export const publicKey = `MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALTbVk5gZwworNOf/6SMMoYeBybEnzaxEmJaDcDEpwv8/5zWRezUtbU5JXrLSeavrO59SdpZCowMDzvuqg/inTkCAwEAAQ==`
const privateKey = `MIIBVQIBADANBgkqhkiG9w0BAQEFAASCAT8wggE7AgEAAkEAtNtWTmBnDCis05//
pIwyhh4HJsSfNrESYloNwMSnC/z/nNZF7NS1tTklestJ5q+s7n1J2lkKjAwPO+6q
D+KdOQIDAQABAkAiavtpvv7dWYBKZdCIyAV1cJF71z9VcS1GekzTupjvtswnHwWa
D6b43O4ASgsF2beDwUovAZRMctwUVwno4VnhAiEA2ZdUXCKLREZX1hffMYKwHjfD
aU3cgy76DW+z16ShLXMCIQDUyAdROAi5WHe/buiUNJvv+gjnRnToSWH3JARXQ8df
owIhALhbTl+N6R9c1jkQGswRJXVE2+1Ryf7gA3704JRZ6THfAiAwIS7GiE4w3nn3
qzagj2XWWlA5QA6hnDe0l0kEFCi80QIhAKPT+8f8h5dX61DY+f8xSAyqS6WAkMUZ
aV37Cvsxy6Ws`

/**
 * 获取服务端的通信加密密钥
 */
export function getConnectKey() {
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  let value1 = encrypt.encrypt(data1)
  const platform = platformAgent()
  if (platform === 'android') {
    val = window.syjs.nativeEncryKey(value1)
    getKey()
  } else if (platform === 'ios') {
    let params = {
      params: {
        value: value1 // 加密过
      },
      success: res => {
        val = res
        getKey()
      }
    }
    execute('nativeEncryKey', params)
    return
    window.webkit.messageHandlers.WKWebViewJavascriptBridge.postMessage(
      'nativeEncryKey' + '?params=' + JSON.stringify(params)
    )
  }
}

export function getKey(v) {
  let decrypt = new JSEncrypt()
  // 设置私钥
  decrypt.setPrivateKey(privateKey)
  // 解密数据
  const data2 = decrypt.decrypt(v)
  if (!data2) {
    alert('没有返回值')
    return
  }
  // 异或运算得到key
  let x = hexToBytes(data1)
  let y = hexToBytes(data2)
  let key = new Array()
  for (let i = 0; i < x.length; i++) {
    key.push(x[i] ^ y[i])
  }
  connectKey = bytesToHex(key).toUpperCase()
}

function hexToBytes(hex) {
  hex = hex.toString()
  for (var bytes = [], c = 0; c < hex.length; c += 2)
    bytes.push(parseInt(hex.substr(c, 2), 16))
  return bytes
}

// Convert a byte array to a hex string
function bytesToHex(bytes) {
  for (var hex = [], i = 0; i < bytes.length; i++) {
    var current = bytes[i] < 0 ? bytes[i] + 256 : bytes[i]
    hex.push((current >>> 4).toString(16))
    hex.push((current & 0xf).toString(16))
  }
  return hex.join('')
}

// 参数加密
export function getParams(params) {
  // let keyHex = CryptoJS.enc.Utf8.parse(key)
  let encrypted = getAesString(params, connectKey, iv) //密文
  let enstr = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
  // alert(JSON.stringify(JSON.parse(params).params))
  return enstr
}

// DES加密
function getAesString(data, key, iv) {
  key = CryptoJS.enc.Latin1.parse(key)
  iv = CryptoJS.enc.Latin1.parse(iv)
  var srcs = CryptoJS.enc.Utf8.parse(data)
  var obj = CryptoJS.DES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return obj
}

export function jiemi(val) {
  var decryptedStr = getDAesString(val, connectKey, iv)
  return decryptedStr
}

function getDAesString(val, key, iv) {
  //解密
  var key = CryptoJS.enc.Latin1.parse(key)
  var iv = CryptoJS.enc.Latin1.parse(iv)
  var decrypted = CryptoJS.DES.decrypt(val, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// 获取随机数
function randomString(len) {
  len = len || 16
  var $chars = 'abcdef0123456789'
  var maxPos = $chars.length
  var pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

// 格式化金额，默认保留两位小数
export function formatMoney(value, num = 2) {
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  if (!value && value != 0) return value
  if (typeof value === 'number') {
    return parseFloat(value).toFixed(num)
  }
  return value
}

// 格式化日期 YYYY-mm-dd HH:MM:SS
export const dateFormat = (stamp, fmt) => {
  if (!stamp) {
    return ''
  }
  if (stamp == '无') {
    return stamp
  }
  if (typeof stamp == 'string') {
    stamp = parseInt(stamp)
  }
  let date = new Date(stamp)
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
      )
    }
  }
  return fmt
}

// 分享微信，不需要加密
export function shareWechat(methodName, params) {
  if (platform === 'android') {
    window.syjs.commonJsBridge(methodName, JSON.stringify(params))
  } else if (platform === 'ios') {
    window.webkit.messageHandlers.WKWebViewJavascriptBridge.postMessage(
      methodName + '?params=' + JSON.stringify(params)
    )
  }
}

// 调用os方法(非加密)
function execOpenFun(methodName, params = {}) {
  const ws_id = generateUUID()
  const obj = {}
  obj.ws_id = ws_id
  obj.params = params.params
  if (params.success) {
    responseCallbacks[ws_id] = params.success
    delete params.success
  }
  if (params.fail) {
    errorCallbacks[ws_id] = params.fail
    delete params.fail
  }
  if (params.complete) {
    completeCallbacks[ws_id] = params.complete
    delete params.complete
  }
  // 进行参数处理 如果有function 的进行方法保存
  if (Object.prototype.toString.call(obj.params) === '[object Object]') {
    if (obj.params.func && typeof obj.params.func === 'function') {
      const func_id = generateUUID()
      obj.params.func_id = func_id
      responseCallbacks[func_id] = obj.params.func
      delete obj.params.func
    }
  }
  // 进行参数处理 如果是批量设置右上角菜单，则进行右上角惨淡判断
  if (
    Object.prototype.toString.call(obj.params) === '[object Array]' &&
    obj.params.length > 0
  ) {
    obj.params.forEach(item => {
      if (item.func && typeof item.func === 'function') {
        const func_id = generateUUID()
        item.func_id = func_id
        responseCallbacks[func_id] = item.func
        delete item.func
      }
    })
  }
  try {
    const platform = platformAgent()
    if (platform === 'android') {
      let params = obj.params
      if (typeof params == 'object') {
        params = JSON.stringify(params)
      }
      window.syjs.nativeJsbridge(methodName, JSON.stringify(obj))
    } else if (platform === 'ios') {
      window.webkit.messageHandlers.WKWebViewJavascriptBridge.postMessage(
        methodName + '?params=' + JSON.stringify(obj)
      )
    }
  } catch (e) {
    console.error(`调用APP接口失败${e}`)
  }
}

// 通用非加密的开放接口
window._openInterface1 = function(params) {
  if (typeof params === 'string') {
    params = JSON.parse(params)
  }
  let ws_id = params.ws_id
  let code = params.code
  let data = params.data
  if (data) {
    if (Object.prototype.toString.call(data) === '[object String]') {
      try {
        data = JSON.parse(data)
      } catch (error) {}
    }
  }
  let successCallback = void 0
  let failCallback = void 0
  let completeCallback = void 0
  if (ws_id) {
    if (code === '200') {
      successCallback = responseCallbacks[ws_id]
      successCallback && successCallback(data)
      // delete responseCallbacks[ws_id]
    } else {
      failCallback = errorCallbacks[ws_id]
      failCallback && failCallback(data)
      // delete errorCallbacks[ws_id]
    }
    completeCallback = completeCallbacks[ws_id]
    completeCallback && completeCallback(data)
    // delete completeCallback[ws_id]
  } else {
    console.error(`no success callback`)
  }
}
